module.exports = __webpack_public_path__ + "img/services-img4.14892bd0.jpg";